import React from 'react';
import { Link } from 'react-router-dom';

function ServiceCategory({ link, category, isActive }) {
    return (
        <>
            <li>
                <Link
                    to={link}
                    className={isActive ? 'active-category' : ''}
                >{category}</Link>
            </li>
        </>
    );
}

export default ServiceCategory;
